export const hasHouseNumber = (
  values: any
): values is Record<string, any> & { houseNumber: string } => {
  return typeof values === 'object' && 'houseNumber' in values
}

export const getAddressFromFields = (fields: Record<string, unknown>) => {
  if (fields.choose_alternative_address) {
    return {
      town: fields.alternative_town,
      zip: fields.alternative_zip,
      house_number: fields.alternative_house_number,
      street: fields.alternative_street,
    }
  }

  // return undefined since it still can be empty string, that isn't valid for schemas string.nonempty()
  return {
    zip: fields.zip_code,
    house_number:
      // houseNumber is a field used in WBF and house_no is used in the user schema
      // there is a difference between user details schema and product schema
      // https://getsafe.slack.com/archives/C03URQ62N82/p1669041691374059
      fields.houseNumber ?? fields.house_no ? fields.houseNumber ?? fields.house_no : undefined,
    town: fields.town ? fields.town : undefined,
    street: fields.street ? fields.street : undefined,
  }
}
